import { DateTimeInput } from "../DateTimeInput/DateTimeInput";

type DateRangeSelectorProps = {
    startDate?: Date;
    endDate?: Date;
    onDateChange: (startDate: Date | undefined, endDate: Date | undefined) => void;
    startDateLabel?: string;
    endDateLabel?: string;
    className?: string;
};

const DateRangeSelectorComponent = (props: DateRangeSelectorProps) => {
    const startDate = props.startDate ? new Date(props.startDate) : undefined;
    const endDate = props.endDate ? new Date(props.endDate) : undefined;

    const isValidRange = !startDate || !endDate || startDate.getTime() <= endDate.getTime();

    const onChangeStartDate = (date: Date | undefined) => {
        const nextStart = date ? new Date(date) : undefined;
        const changed = (nextStart?.getTime() || undefined) !== (startDate?.getTime() || undefined);
        if (changed) {
            props.onDateChange(nextStart, endDate);
        }
    };

    const onChangeEndDate = (date: Date | undefined) => {
        const nextEnd = date ? new Date(date) : undefined;
        const changed = (nextEnd?.getTime() || undefined) !== (endDate?.getTime() || undefined);
        if (changed) {
            props.onDateChange(startDate, nextEnd);
        }
    };

    return (
        <div className={props.className ?? "date-range-selector"}>
            <DateTimeInput
                label={props.startDateLabel}
                placeHolder="fecha de inicio"
                selectedDate={startDate}
                isSubmitted={false}
                isRequired={false}
                errorMessage={undefined}
                onSelectDate={onChangeStartDate}
            />
            <DateTimeInput
                label={props.endDateLabel}
                placeHolder="fecha de fin"
                selectedDate={endDate}
                isSubmitted={false}
                isRequired={false}
                errorMessage={undefined}
                onSelectDate={onChangeEndDate}
            />
            {!isValidRange && (
                <small className="error">La fecha de inicio no puede ser mayor a la fecha de fin</small>
            )}
        </div>
    );
};

export default DateRangeSelectorComponent;